module.exports = __webpack_public_path__ + "static/img/logo_blue.89dccb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/logo_blue.svg
// module id = MZ8B
// module chunks = 3